import { GET_BENEFIT_CATEGORY, GET_BENEFIT_CATEGORY_SUCCESS, GET_BENEFIT_CATEGORY_ERROR, GET_BENEFIT_CATEGORY_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBenefitCategory = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_CATEGORY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_CATEGORY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_BENEFIT_CATEGORY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BENEFIT_CATEGORY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBenefitCategory;
